Vue.component('ack-sol-build-platforms', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-sol-build-platforms',
	mixins: [languageMixins],
	created() {},
	mounted() {
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
		shopProductInfo: {
			type: Object,
			required: false,
		},
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('shop', ['currentCurrency', 'currentCurrencySymbol', 'currentCountryCode']),
		isMobile() {
			return this.$parent.isMobile;
		},
		productIsNotAvailableInRegion() {
			let notAvailable = false;
			if (
				this.currentCountryCode.toUpperCase() == 'US' ||
				this.currentCountryCode.toUpperCase() == 'CA'
			) {
				notAvailable = true;
			}
			return notAvailable;
		},
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			isUsaOrCa: this.$store.getters['localization/isUS_CA'],
			pageId: 'sol-build-platforms-page',
			solBpProducts: [
				{
					productImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/mediumBP.gif?v=1647415683',
					iconImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/medium-ico.png?v=1647919012',
					title: 'Medium Build Platform',
					productId: 'gid://shopify/Product/6630922485863',
					variantId: 'gid://shopify/ProductVariant/39604337836135',
					sellingPlanId: null,
					details: [
						'Printing area: 70 x 70 mm',
						'Finishing: Anodized Metal',
						'Compatibility: SOL 3D Printer',
					],
					price: '$7,205.00',
					disclaimer: '*This price does NOT include Shipping, Handling, Customs or Local VAT',
				},
				{
					productImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/smallBP.gif?v=1647415137',
					iconImage:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/small-ico.png?v=1647919012',
					title: 'Small Build Platform',
					productId: 'gid://shopify/Product/6630921502823',
					variantId: 'gid://shopify/ProductVariant/39604336754791',
					sellingPlanId: null,
					details: [
						'Printing area: 40 x 20 mm',
						'Finishing: Anodized Metal',
						'Compatibility: SOL 3D Printer',
					],
					price: '$7,205.00',
					disclaimer: '*This price does NOT include Shipping, Handling, Customs or Local VAT',
				},
			],
			solBpFeatures: [
				{
					icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/medium-ico.png?v=1647919012',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_model-Dentiq.png?v=1636103938',
					title: 'Model',
					time: '28 Minutes',
					efficiency: '35% Faster',
				},
				{
					icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/small-ico.png?v=1647919012',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_crown-Dentiq.png?v=1636103938',
					title: 'Crown & Bridge',
					time: '15 Minutes',
					efficiency: '40% Faster',
				},
				{
					icon: null,
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_Denture-base-Dentiq_80063dbd-4111-462c-8520-e69387da072e.png?v=1648715630',
					title: 'Dentures',
					time: '53 Minutes',
					efficiency: '26% Faster',
				},
				{
					icon: null,
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_Castable-Crown-Dentiq.png?v=1636103938',
					title: 'Cast',
					time: '30 Minutes',
					efficiency: '50% Faster',
				},
				{
					icon: null,
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_guide-Dentiq.png?v=1636103939',
					title: 'Surgical Guide',
					time: '33 Minutes',
					efficiency: '23% Faster',
				},
				{
					icon: null,
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_gingiva-Dentiq.png?v=1636103938',
					title: 'Gingiva',
					time: '30 Minutes',
					efficiency: '10% Faster',
				},
				{
					icon: null,
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/print_IBT-Dentiq.png?v=1636103938',
					title: 'IBT',
					time: '84 Minutes',
					efficiency: '32% Faster',
				},
			],

			slidersInfo: {
				hover_slider_image_section: {
					title: 'Build Platforms Engineered to Meet Your Clinical Needs',
					description:
						'The Small, Medium, and Large build platforms are designed to optimize print times and resin usage for specific applications, ranging from rapid crown production in just 20 minutes to efficient full-arch printing. Choose the ideal platform to achieve unmatched speed and precision in your dental 3D printing.',
					image_items: [
						{
							link: 'https://ackuretta.com/pages/store?bundle=shop-3dps-9',
							src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_L_Build_Platform_Banner.jpg?v=1739522191',
							alt: 'Large Build Platform',
							title: 'Large Build Platform',
						},
						{
							link: 'https://ackuretta.com/pages/store?bundle=shop-3dps-9',
							src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_M_Build_Platform_Banner.jpg?v=1739522184',
							alt: 'Medium Build Platform',
							title: 'Medium Build Platform',
						},
						{
							link: 'https://ackuretta.com/pages/store?bundle=shop-3dps-9',
							src: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_S_Build_Platform_Banner.jpg?v=1739522191',
							alt: 'Small Build Platform',
							title: 'Small Build Platform',
						},
					],
				},
			},

			productInfo: {
				default_3dps_bundle: 'shop-3dps-9',
				bundle_title: 'Buy SOL Build Platforms',
				title_section: {
					title: 'SOL Build Platforms',
					subtitle: 'Build Platforms<br>Optimize Your Print Speed<br>',
					// title_image_text: 'SOL Build Platforms',
					title_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Logo_Resize-01.png?v=1704958182',
					description: 'Transform your dental workflow with our versatile build platforms.',
					image_mobile:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_Top_banner.jpg?v=1739521754&quot',
					image_desktop:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_Top_banner.jpg?v=1739521754',
				},
			},
			scrollingInfo: {
				scrolling_section: {
					title: 'What makes SOL Build Platforms the ideal choice?',
					scrolling_items: [
						{
							title: 'Smaller Surface, For Faster Print Times',
							description:
								'A smaller Build Platform displaces less resin, reducing wait times between layers.',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/S_vs_L_2_1.gif?v=1747383232',
						},
						{
							title: 'Anodized Finish For Improved Adhesion',
							description:
								"Ackuretta's breakthrough innovation ensures strong adhesion to the Build Platform, minimizing the risk of print failure.",
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/1-1_photo.jpg?v=1648177867',
						},
						{
							title: 'Unmatched Versatility',
							description:
								"Print what you need, when you need it. Whether it's a full arch or a crown, choose from two sizes for maximum flexibility.",
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/1-3_photo.jpg?v=1648177867',
						},
						{
							title: 'Innovation, Refined',
							description:
								'There are three key factors that influence printing speed. Learn more about the technology behind this innovation.',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_Photo.jpg?v=1739521891',
						},
					],
				},
			},
			image_section: {
				title: 'Experience the Difference With 1-hour Workflows',
				url_image: null,
				image:
					'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/BP_Page_Crown_Workflow.jpg?v=1739521984',
				imgAlt: 'Experience_the_Difference_With_1-hour_Workflows_Img',
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList']),
		...Vuex.mapActions('shop', ['addToCartFromProperties']),
		onAddToCartClick(solBpProducts) {
			appLog.log(`onAddToCart${solBpProducts.title}Click`, LOG_TYPE.debug);
			this.addToCartFromProperties({
				productId: solBpProducts.productId,
				variantId: solBpProducts.variantId,
				sellingPlanId: solBpProducts.sellingPlanId,
			});
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
